export const acceptTermsAndConditionsMutation = `
  mutation AcceptTermsAndConditions($input: AcceptTermsAndConditionsInput!) {
    acceptTermsAndConditions(input: $input) {
      terms_and_conditions_acceptance_id
      person_id
      terms_of_service_version_id
      privacy_policy_version_id
      accepted_date
      ip_address
      browser
      corporation_id
      created_by
      created_date
      active
    }
  }
`
export const upsertForwardingAddressMutation = `
  mutation upsertForwardingAddress($personIds: [String!]!, $addressInput: ForwardingAddressInput!) { 
    upsertForwardingAddress(personIds: $personIds, addressInput: $addressInput) { 
        address_id
        address_line_1
        address_line_2
        city
        state
        postal_code
        country_code
        person_id
  }
}

`
